
// Helper function to categorize job titles into departments
export const categorizeJobTitle = (title: string): string => {
  const titleLower = title.toLowerCase();
  
  if (titleLower.includes('sales') || titleLower.includes('account') || titleLower.includes('business development')) {
    return 'Sales';
  } else if (titleLower.includes('market') || titleLower.includes('content') || titleLower.includes('brand')) {
    return 'Marketing';
  } else if (titleLower.includes('engineer') || titleLower.includes('develop') || titleLower.includes('tech') || 
            titleLower.includes('code') || titleLower.includes('program') || titleLower.includes('software')) {
    return 'Engineering';
  } else if (titleLower.includes('support') || titleLower.includes('customer') || titleLower.includes('service')) {
    return 'Support';
  } else if (titleLower.includes('hr') || titleLower.includes('human resource') || titleLower.includes('recruit') || 
            titleLower.includes('talent')) {
    return 'HR';
  } else if (titleLower.includes('finance') || titleLower.includes('account') || titleLower.includes('financial') || 
            titleLower.includes('book') || titleLower.includes('budget')) {
    return 'Finance';
  } else {
    return 'Other';
  }
};
